module.exports = __webpack_public_path__ + "img/facebook.79ce6692.svg";